module.exports = __webpack_public_path__ + "media/images/athletes/2367-8fbe0bcfa6a641f1f6458a6e7685ba8c.png";